export const categoryConfig = {
  headwear: {
    label: 'Headwear',
    order: 1,
  },
  outerwear: {
    label: 'Outerwear',
    order: 2,
  },
  tops: {
    label: 'Tops',
    order: 3,
  },
  bottoms: {
    label: 'Bottoms',
    order: 4,
  },
  footwear: {
    label: 'Footwear',
    order: 5,
  },
  accessories: {
    label: 'Accessories',
    order: 6,
  },
  underwear: {
    label: 'Underwear',
    order: 7,
  },
  fullbody: {
    label: 'Full Body',
    order: 8,
  },
  fragrances: {
    label: 'Fragrances',
    order: 9,
  },
} as const
